<template>
  <section class="tables">
    <b-form @submit.prevent="createRoute">
      <div class="row">
        <Breadcrumb :breadcrumbs="breadcrumbs" />

        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <b-form-group
                label="Title"
                label-for="title-input"
                label-cols-sm="4"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="7"
              >

                <b-form-input
                  id="title-input"
                  v-model.trim="$v.form.title.$model"
                  type="text"
                  placeholder="Enter title "
                  :class="{
                    'is-invalid': submitted && $v.form.title.$error,
                  }"
                  :state="validateState('title')"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.form.title.required"
                  class="invalid-feedback"
                >
                  title is required
                </div>
              </b-form-group>
              <b-form-group
                label="Route Type"
                label-cols-sm="4"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="7"
              >
                <b-form-radio-group
                  v-model="form.type"
                  :options="routeTypes"
                  name="routeType"
                ></b-form-radio-group>
              </b-form-group>


              <b-form-group
                v-if="form.type === 'RETURN'"
                label="Select Forward Route"
                label-cols-sm="4"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="7"
              >
                <multiselect
                  v-model="form.linkedRouteId"
                  :options="forwardRoutes"
                  placeholder="Select forward route"
                  label="title"
                  track-by="_id"
                >
                  <template slot="option" slot-scope="props">
                    {{ props.option.title }}
                  </template>
                </multiselect>

                <b-form-invalid-feedback v-if="submitted && !$v.form.linkedRouteId.required">
                  Forward route is required
                </b-form-invalid-feedback>
              </b-form-group>




              
            </div>
          </div>
        </div>

        <!-- Start Point -->

        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <table id="ferriRouteTable" class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="col-md-5">Stops</th>
                    <!-- <th scope="col" class="col-md-3">Duration</th> -->
                    <th scope="col" class="col-md-3">Minimum Fare</th>
                    <th scope="col" class="col-md-4">Price per km</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    id="fr_Route_122"
                    v-for="(data, k) in this.form.stops"
                    :key="k"
                  >
                    <td scope="row">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <multiselect
                              v-model.trim="data.location"
                              :options="options"
                              placeholder="start typing to search locations.."
                              label="title"
                              track-by="title"
                              :searchable="true"
                              :loading="submitted"
                              @search-change="fetchLocations"
                            >
                              <template slot="option" slot-scope="props">
                                {{ props.option.title }}
                              </template>
                              <template slot="noOptions">
                                No stop found.</template
                              >
                              <template slot="noResult">
                                Stop searched not matched.</template
                              >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="row">
                        <label class="col-sm-4">if pick-up</label>
                        <div class="col-sm-8">
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="data.minimum_fare_pickup"
                            value="1"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-sm-4">if drop</label>
                        <div class="col-sm-8">
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="data.minimum_fare_drop"
                            value="1"
                          />
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="row">
                        <label class="col-sm-3">if pick-up</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <input
                              type="number"
                              min="1"
                              v-model="data.price_per_km_pickup"
                              class="form-control"
                              aria-label="Amount (to the nearest rupee)"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">.00</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <label class="col-sm-3">if drop</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <input
                              type="number"
                              min="1"
                              v-model="data.price_per_km_drop"
                              class="form-control"
                              aria-label="Amount (to the nearest rupee)"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">.00</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td class="trashIconContainer">
                      <!-- Add row icon -->
                      <i
                        @click="addRowAt(k)"
                        class="mdi mdi-plus-circle-outline mdi-24px addIcon"
                        title="Add stop below"
                      ></i>

                      <!-- Delete row icon -->
                      <span v-if="k > 0">
                        <i
                          @click="removeRow(k, data)"
                          class="mdi mdi-delete-forever mdi-24px deleteIcon"
                          title="Delete stop"
                        ></i>
                      </span>
                    </td>

                  </tr>
                </tbody>
              </table>
              <div class="d-flex justify-content-center">
                <input
                  name="addpd"
                  @click="addRow"
                  class="btn btn-outline-primary mt-4"
                  type="button"
                  value="+ Add Departure / Arrival location"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- End Point -->

        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <table id="ferriRouteTable" class="table table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="col-md-5">Destination</th>
                    <!-- <th scope="col" class="col-md-3">Duration</th> -->
                    <th scope="col" class="col-md-3">Minimum Fare</th>
                    <th scope="col" class="col-md-4">Price per km</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td scope="row">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="form-group">
                            <multiselect
                              v-model.trim="finalData.location"
                              :options="options"
                              placeholder="start typing to search locations.."
                              label="title"
                              track-by="title"
                              :searchable="true"
                              :loading="submitted"
                              @search-change="fetchLocations"
                            >
                              <template slot="option" slot-scope="props">
                                {{ props.option.title }}
                              </template>
                              <template slot="noOptions">
                                No stop found.</template
                              >
                              <template slot="noResult">
                                Stop searched not matched.</template
                              >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="row">
                        <label class="col-sm-4">if pick-up</label>
                        <div class="col-sm-8">
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="finalData.minimum_fare_pickup"
                            value="1"
                          />
                        </div>
                      </div>
                      <div class="row">
                        <label class="col-sm-4">if drop</label>
                        <div class="col-sm-8">
                          <input
                            type="number"
                            min="1"
                            class="form-control"
                            v-model="finalData.minimum_fare_drop"
                            value="1"
                          />
                        </div>
                      </div>
                    </td>

                    <td>
                      <div class="row">
                        <label class="col-sm-3">if pick-up</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <input
                              type="number"
                              min="1"
                              v-model="finalData.price_per_km_pickup"
                              class="form-control"
                              aria-label="Amount (to the nearest rupee)"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">.00</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <label class="col-sm-3">if drop</label>
                        <div class="col-sm-9">
                          <div class="input-group">
                            <input
                              type="number"
                              min="1"
                              v-model="finalData.price_per_km_drop"
                              class="form-control"
                              aria-label="Amount (to the nearest rupee)"
                            />
                            <div class="input-group-append">
                              <span class="input-group-text">.00</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <b-form-group
                label="Status "
                label-for="status-input"
                invalid-feedback="status is required"
                class="mt-3"
                label-cols-sm="4"
                label-cols-lg="3" 
                content-cols-sm
                content-cols-lg="7"
              >
                <b-form-radio-group
                  :options="statusOptions"
                  v-model.trim="$v.form.status.$model"
                  name="status"
                ></b-form-radio-group>

                <b-form-invalid-feedback
                  v-if="submitted && !$v.form.status.required"
                  >Please select one</b-form-invalid-feedback
                >
              </b-form-group>
              <br /><br />
              <b-form-group class="col-md-6 offset-md-5">
                <b-button
                  type="submit"
                  class="btn btn-success btn-lg text-center mr-2"
                >
                  <span
                    class="pl-2 spinner-border spinner-border-sm"
                    v-show="submitted"
                  >
                  </span>
                  Create</b-button
                >
                <b-button
                  :to="{ name: 'route' }"
                  class="btn btn-default btn-lg text-center"
                  >Back</b-button
                >
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </b-form>
  </section>
</template>

<script>
import Breadcrumb from "../../../components/breadcrumb";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import vSelect from "vue-select";
// import "vue-select/src/scss/vue-select.scss";
import { locationService, routeService } from "../../../services";
import lodash from "lodash";
import Multiselect from "vue-multiselect";

export default {
  mixins: [validationMixin],
  name: "routes",
  components: {
    Breadcrumb,
    Multiselect,
  },
  data() {
    return {
      breadcrumbs: {
        title: "Create Route",
        b1: "Manage Routes",
        b2: "Routes",
        b3: "Index",
        link: true,
        name: "route",
      },
      routeTypes: [
        { text: "Forward", value: "FORWARD" },
        { text: "Return", value: "RETURN" }
      ],
      submitted: false,
      loading: false,
      options: [],
      pds: [],
      finalData: {
        location: {},
        duration_pickup: "",
        duration_drop: "",
        minimum_fare_pickup: "",
        minimum_fare_drop: "",
        price_per_km_pickup: "",
        price_per_km_drop: "",
      },
      form: {
        title: "",
        type: "FORWARD",
        linkedRouteId: null,
        stops: [
          {
            location: [{}],
            duration_pickup: "",
            duration_drop: "",
            minimum_fare_pickup: "",
            minimum_fare_drop: "",
            price_per_km_pickup: "",
            price_per_km_drop: "",
            files: [],
          },
        ],
        status: true,
      },
      forwardRoutes: [],
      buses: [],
      statusOptions: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
    };
  },
  validations: {
    form: {
      title: { required },
      type: { required },
      status: { required },
      linkedRouteId: {
        required(value) {
          return this.form.type === "RETURN" ? !!value : true;
        }
      }
    },
  },


  watch: {
    "form.type"(newVal) {
      if (newVal === "RETURN") {
        this.fetchForwardRoutes();
      } else {
        this.form.linkedRouteId = null;
      }
    }
  },
  methods: {

    async fetchForwardRoutes() {
      try {
        const res = await routeService.getRouteTitle();

        // res = { data: [...] }
        this.forwardRoutes = Array.isArray(res?.data)
          ? res.data
          : [];

          // console.log("forward routes: ",res.data);
      } catch (err) {
        this.forwardRoutes = [];
        this.$toast.open({
          message: "Failed to load forward routes",
          type: "error",
        });
      }
    },

    addRow: function () {
      this.form.stops.push({
        location: {},
        duration_pickup: "",
        duration_drop: "",
        minimum_fare_pickup: "",
        minimum_fare_drop: "",
        price_per_km_pickup: "",
        price_per_km_drop: "",
        files: "",
        order: this.form.stops.length + 1,
      });
    },
    addRowAt(index) {
      this.form.stops.splice(index + 1, 0, {
        location: {},
        duration_pickup: "",
        duration_drop: "",
        minimum_fare_pickup: "",
        minimum_fare_drop: "",
        price_per_km_pickup: "",
        price_per_km_drop: "",
        files: "",
      });
    },
    removeRow(index, data) {
      // console.log("data", index, data);
      var idx = this.form.stops.indexOf(data);
      console.log(idx, index);
      if (idx > -1) {
        this.form.stops.splice(idx, 1);
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async createRoute() {
      try {
        this.submitted = true;

        // stop here if form is invalid
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        // clone stops
        const stopsWithEnd = [...this.form.stops];

        // if finalData has location, append it as last stop
        if (
          this.finalData.location &&
          Object.keys(this.finalData.location).length
        ) {
          stopsWithEnd.push({
            ...this.finalData,
          });
        }

        // Assign order to each stop (starting from 1, or 0 as per backend convention)
        const stopsWithOrder = stopsWithEnd.map((stop, idx) => ({
          ...stop,
          order: idx + 1, // or idx, as needed
        }));

        // keep same payload structure
        const payload = {
          ...this.form,
          linkedRouteTitle: this.form.linkedRouteId?._id || null,
          stops: stopsWithOrder,
        };

        // console.log("Final Payload:", payload);

        const response = await routeService.create(payload);
        if (response.status) {
          this.submitted = false;
          this.$toast.open({
            message: response.message,
            type: "success",
            position: "top-right",
            duration: 2000,
            // all of other options may go here
          });
          setTimeout(
            () =>
              this.$router.push({
                path: `/routes`,
              }),
            2000
          );
        }
      } catch (e) {
        this.$toast.open({
          message: e || "Something went wrong",
          type: "error",
          position: "top-right",
          duration: 5000,
        });
      }
    },
    
    
    
    fetchLocations(search) {
      if (!search || !search.length) return;
      // console.log(search);
      this.searchLocations(search);
    },

    searchLocations: lodash.debounce(async function (search) {
      try {
        const response = await locationService.search(search);
        // console.log(response);
        this.options = Array.isArray(response?.items) ? response.items : [];
      } catch (err) {
        this.$toast.open({
          message: err?.message || "Failed to fetch locations",
          type: "error",
          position: "top-right",
          duration: 5000,
        });
      }
    }, 350),
  },
};
</script>

<style scoped>
.trashIconContainer i {
  color: #e74c3c;
  cursor: pointer;
}
.d-center {
  display: flex;
  align-items: center;
}
/* .v-select .dropdown li {
    border-bottom: 1px solid rgba(112, 128, 144, 0.1);
  }

  .v-select .dropdown li:last-child {
    border-bottom: none;
  }

  .v-select .dropdown li a {
    padding: 10px 20px;
    width: 100%;
    font-size: 1.25em;
    color: #3c3c3c;
  }

  .v-select .dropdown-menu .active > a {
    color: #fff;
  }
  .vs__dropdown-toggle {
    padding: 0 0 10px 0 !important;
  }
  .vs__actions {
    padding: 13px 6px 0 3px !important;
  }
  .vs__selected {
    margin: 14px 2px 0px 2px !important;
  } */
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
